import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import WhoWeHelp from "@/components/WhoWeHelp";
import CoachNote from "@/components/CoachNote";
import Gallery from "@/components/Gallery";
import CoreTabs from "@/components/CoreTabs";
import FAQ from "@/components/FAQ";
import Consult from "@/components/Consult";
import WhatsAppFab from "@/components/WhatsAppFab";
import AICoach from "@/components/AICoach";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-background min-h-screen" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <WhoWeHelp />
        <CoachNote />
        <Gallery />
        <CoreTabs />
        <FAQ />
        <Consult />
      </main>
      <Footer />
      <WhatsAppFab />
      <AICoach />
      <Toaster position="bottom-left" theme="dark" />
    </div>
  );
}

export default App;
